
import {
  signOfflineBatch, selectPageListNew, exportWaybillInfo4CashingRate,
  actualTraceInfo, planTraceInfo, selectByWaybillNo,
} from '@/services/waybillCashRateNew';
import moment, { utc } from 'moment';
import { message } from 'antd';

const today = new Date();

const params = {
  waybillNo: [],
  originProvince: '',
  countyAgingOriginCenter: '',
  isProduct: undefined, //[SuperiorityProduct.YES, SuperiorityProduct.NO],
  startDate: moment(today).add(-1, 'days').format('YYYY-MM-DD 00:00:00'),
  destinationProvinceArea: '',
  countyAgingDestinationCenter: '',
  productType: [],
  scanTimeType: '10'
};

const actualTable = 'static_actual_time_consume_result'; // 实际表
const preTable = 'static_actual_time_consume_result_sat';

export default {
  namespace: 'waybillcashratenew2',
  state: {
    searchParams: { ...params },
    dataList: [],
    dataSql: '',
    page: 1,
    pageSize: 20,
    scheduleImportVo: [],
    messageInfo: '',
    detailModalVisible: false,
    infoData: null,
    planTraceInfo: null,
    actualTraceInfo: null,
    waybillNoInfo: null,
    // infoData: { adasd: 122 }
    // importLoding: false,
  },

  effects: {
    *getData({ payload }, { put, call, select }) {
      const waybillcashratenew2 = yield select(({ waybillcashratenew2 }) => waybillcashratenew2);
      const { searchParams, page, pageSize } = waybillcashratenew2;
      const {
        startDate,
        waybillNo,
        originProvince,
        countyAgingOriginCenter,
        isProduct,
        destinationProvinceArea,
        countyAgingDestinationCenter,
        productType,
        scanTimeType,
        onTimesValue
      } = searchParams;
      let onTimes = [];
      if (onTimesValue === 10) {
        onTimes = [0, 10]
      } else if (onTimesValue === 20) {
        onTimes = [20, 30]
      }
      const pages = payload?.page ?? page;
      let result = yield call(selectPageListNew, {
        waybillNos: waybillNo || [],
        originArea: originProvince?.code,
        originCenterCode: countyAgingOriginCenter?.code,
        isSuperiorityProduct: isProduct,
        destinationArea: destinationProvinceArea?.code,
        destinationCenterCode: countyAgingDestinationCenter?.code,
        productType: productType,
        scanTimeType: scanTimeType,
        startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
        endDate: moment(startDate).format('YYYY-MM-DD 23:59:59'),
        queryType: 'scan',
        onTimes: onTimes,
        page: pages,
        pageSize,
      });

      yield put({
        type: 'updateState',
        payload: {
          dataList: result?.data?.rows || [],
          total: result?.data?.total || 0,
          page: pages,
        },
      });
    },
    *getWayBillInfo({ payload }, { put, call, select }) {
      const waybillcashratenew2 = yield select(({ waybillcashratenew2 }) => waybillcashratenew2);
      const waybillNo = payload.waybillNo;
      let data = yield call(planTraceInfo, { waybillNo });
      if (data && data.code === 1) {
        yield put({
          type: 'updateState',
          payload: {
            planTraceInfo: data.data,
          },
        });
      }
      let actualData = yield call(actualTraceInfo, { waybillNo });
      if (actualData && actualData.code === 1) {
        yield put({
          type: 'updateState',
          payload: {
            actualTraceInfo: actualData.data,
          },
        });
        if (actualData.data && actualData?.data?.waybillNo) {
          let selectByWaybillNoData = yield call(selectByWaybillNo, { waybillNo });
          if (selectByWaybillNoData && selectByWaybillNoData.code === 1) {
            let dataList = [];
            if (selectByWaybillNoData?.data) {
              dataList = selectByWaybillNoData.data.map((item, index) => {
                return {
                  key: `${index}`,
                  ...item,
                };
              });
            }
            yield put({
              type: 'updateState',
              payload: {
                waybillNoInfo: dataList,
              },
            });
          }
        }
      }


    },
    *dataExport({ payload }, { call, put, select }) {
      const waybillcashratenew2 = yield select(({ waybillcashratenew2 }) => waybillcashratenew2);
      const { searchParams, page, pageSize } = waybillcashratenew2;

      const {
        startDate,
        waybillNo,
        originProvince,
        countyAgingOriginCenter,
        isProduct,
        destinationProvinceArea,
        countyAgingDestinationCenter,
        productType,
        scanTimeType
      } = searchParams;

      const pages = payload?.page ?? page;

      let result = yield call(exportWaybillInfo4CashingRate, {
        waybillNos: waybillNo || [],
        originArea: originProvince?.code,
        originCenterCode: countyAgingOriginCenter?.code,
        isSuperiorityProduct: isProduct,
        destinationArea: destinationProvinceArea?.code,
        destinationCenterCode: countyAgingDestinationCenter?.code,
        productType: productType,
        scanTimeType: scanTimeType,
        startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
        endDate: moment(startDate).format('YYYY-MM-DD 23:59:59'),
        queryType: 'scan',
        page: pages,
        pageSize,
        ...payload,
      });
      try {
        if (result?.code === 1) {
          message.success('导出成功');
          yield put({
            type: 'updateState',
            payload: {
              exportVisible: false,
            },
          });
          // yield put({
          //   type: 'filedownload/deliveryDisAccordExport',
          //   payload: {
          //     ...searchParams,
          //     endDate: moment(searchParams.startDate).format('YYYY-MM-DD HH:mm:ss'),
          //     startDate: moment(searchParams.endDate).format('YYYY-MM-DD HH:mm:ss'),
          //   }
          // });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },

    // 导入
    *signOfflineBatch({ callBack }, { select, call }) {
      const { scheduleImportVo } = yield select(({ waybillcashratenew2 }) => waybillcashratenew2);
      if (!scheduleImportVo?.length) return message.error('导入文件数据为空');
      const result = yield call(signOfflineBatch, { staticSignOfflineImportVos: scheduleImportVo });
      // console.log(result)
      if (result?.code === 1) {
        // message.success( result.message || '导入成功！')
        callBack && callBack(result);
      } else {
        message.error('导入文件出现异常,服务端没有响应!');
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
